<form [formGroup]="formGroup" class="bg-white">
  <div class="development-title !text-[#21252A] !pl-[36px] sticky top-0 !z-50">
    Pre-Qualification Questionnaire (PQQ)
    <span class="comapny-general-info !text-[#343A40]">
      Sustainability and Social Value  </span
    >
  </div>

  <div class="grid grid-cols-1 md:grid-cols- gap-x-[5rem] m-5 px-[17px]">
    <!-- Sustainability and Social Value  -->
    <div>
      <h3 class="pb-4 !text-[#21252A] pl-0 !m-0">Sustainability</h3>
      <div class="min-h-[20vh]">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label> Outline Company Sustainability </mat-label>
          <textarea
            matInput
            formControlName="sustainability_outline"
            placeholder="Outline how your company promotes sustainability in construction projects."
            rows="5"
          ></textarea>
        </mat-form-field>
        <div class="mt-[3.5rem]">
          <app-file-manager
            [newFileControlName]="'SustainabilityFileControl'"
            (newFilesUpdatedEvent)="handleNewFiles($event)"
            [oldFiles]="oldSustainabilityFiles"
            (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
          ></app-file-manager>
        </div>
      </div>
      <div class="min-h-[20vh] mt-6">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label> Examples of any sustainability initiatives </mat-label>
          <textarea
            matInput
            formControlName="sustainability_initiatives_taken"
            placeholder="Provide examples of any sustainability initiatives or innovations on previous projects (e.g., carbon reduction, waste management, energy efficiency)."
            rows="5"
          ></textarea>
        </mat-form-field>
        <div class="mt-[3.5rem]">
          <app-file-manager
            [newFileControlName]="'SustainabilityInitiativesFileControl'"
            (newFilesUpdatedEvent)="handleNewFiles($event)"
            [oldFiles]="oldSustainabilityInitiativesFiles"
            (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
          ></app-file-manager>
        </div>
      </div>
    </div>

    <div>
      <h3 class="py-4 pl-0 !text-[#21252A] !m-0">Social Value</h3>
      <div class="min-h-[20vh]">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>
            Outline the company contribution to the local community
          </mat-label>
          <textarea
            matInput
            formControlName="social_contributions_community_and_industry"
            placeholder="Describe how your company contributes to the local community and the wider industry (e.g., apprenticeship schemes, community engagement, skills development)."
            rows="5"
          ></textarea>
        </mat-form-field>
        <div class="mt-[3.5rem]">
          <app-file-manager
            [newFileControlName]="'SocialValuesFileControl'"
            (newFilesUpdatedEvent)="handleNewFiles($event)"
            [oldFiles]="oldSocialValuesFiles"
            (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
          ></app-file-manager>
        </div>
      </div>
      <div class="min-h-[20vh] mt-6">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>
            Are you involved in any corporate social responsibility (CSR)
            Initiatives?
          </mat-label>
          <textarea
            matInput
            formControlName="corporate_social_initiatives"
            placeholder="Are you involved in any corporate social responsibility (CSR) Initiatives?"
            rows="5"
          ></textarea>
        </mat-form-field>
        <div class="mt-[3.5rem]">
          <app-file-manager
            [newFileControlName]="'CorporateResponsibilityFileControl'"
            (newFilesUpdatedEvent)="handleNewFiles($event)"
            [oldFiles]="oldCorporateResponsibilityFiles"
            (oldFilesDeletedEvent)="handleDeletedOldFiles($event)"
          ></app-file-manager>
        </div>
      </div>
    </div>
  </div>
</form>
